import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, tap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ModalService } from '../services/modal.service';
import { GlobalName } from './global-name';
import { LocalStorageService } from './local-stoarge-service';

export const appHttpInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const lsService = inject(LocalStorageService);
  const modalService = inject(ModalService);

  const token = authService.getJWTToken();
  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
    },
  });

  return next(authReq).pipe(
    // Surface status:false in HTTP 200 responses as proper errors
    tap((event) => {
      if (event instanceof HttpResponse && event.body !== null && typeof event.body === 'object') {
        const body = event.body as any;
        if (body.status === false) {
          throw new HttpErrorResponse({
            error: body,
            status: 422,
            statusText: body.message ?? 'Erreur',
            url: req.url,
          });
        }
      }
    }),
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        lsService.remove(GlobalName.tokenName);
        lsService.remove(GlobalName.refreshTokenName);
        lsService.remove(GlobalName.expireIn);
        lsService.remove(GlobalName.userName);
        lsService.remove(GlobalName.exercice);
        modalService.dismissAll();
        router.navigate(['/login']);
      }
      return throwError(() => error);
    })
  );
};
